<template>
  <div>
    <div class="left-image-decor"></div>
    <div class="right-image-decor"></div>
    <section class="section" id="methodology">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <div class="center-heading">
              <h2><em>Methodology</em></h2>
              <p>
                <span style="color: #008e43" class="text-uppercase"
                  ><strong>Introduction</strong></span
                >
              </p>
              <ol>
                <li>
                  <p>
                    The Edge ESG Awards is aimed at acknowledging public-listed
                    companies (PLCs) and asset management firms that are ESG
                    leaders in Malaysia.
                  </p>
                </li>
                <li>
                  <p>There are two categories to the awards:</p>
                  <ol type="a">
                    <li>
                      <p>
                        Equities: The Edge is working with Bursa Malaysia and
                        FTSE Russell to reward best-performing PLCs using
                        FTSE&rsquo;s methodology;
                      </p>
                    </li>
                    <li>
                      <p>
                        Funds: The Edge is working with Morningstar to reward
                        best-performing asset management firms using its
                        methodology.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    The winner&rsquo;s list will be published in The Edge
                    Weekly.
                  </p>
                </li>
                <li>
                  <p>
                    There is no application process to participate in the
                    Awards. Companies that are in the eligible universe will be
                    considered for the Awards. The eligible universe for the
                    equities category are PLCs that are constituents of the FTSE
                    Bursa Malaysia EMAS Index, while the eligible universe for
                    the funds category are funds that qualify as Sustainable and
                    Responsible Investment Funds, according to the Securities
                    Commission Malaysia.
                  </p>
                </li>
              </ol>

              <p>
                <span style="color: #008e43" class="text-uppercase"
                  ><strong>The Edge ESG Awards Equities Category</strong></span
                >
              </p>
              <ol>
                <li>
                  <p>Eligibility:</p>
                  <ol type="a">
                    <li>
                      <p>
                        PLCs must be constituents of the FTSE Bursa Malaysia
                        EMAS index as of June 2022.
                      </p>
                    </li>
                    <li>
                      <p>Excluded:</p>
                      <ol type="i">
                        <li>
                          <p>Manufacturers of tobacco, coal and weapons;</p>
                        </li>
                        <li>
                          <p>
                            PLCs that are excluded from the FTSE4Good Bursa
                            Malaysia (F4GBM) Index due to controversies or for
                            failing to address specific product requirements;
                          </p>
                        </li>
                        <li>
                          <p>
                            PLCs that are suspended, under the stock
                            exchange&rsquo;s watchlist or subsequently delisted
                            prior to the date of The Edge-ESG Awards;
                          </p>
                        </li>
                        <li>
                          <p>
                            PLCs that have significant adverse news related to
                            ESG in the past year;
                          </p>
                        </li>
                        <li>
                          <p>
                            PLCs that do not meet the minimum Climate Change
                            score thresholds as per the FTSE4Good Index series
                            inclusion rules. The thresholds are determined by
                            FTSE&rsquo;s classification for Emerging Markets
                            according to the FTSE Country Classification scheme,
                            and by the PLCs&rsquo; Industry Classification
                            Benchmark (ICB) Subsector level assignment.
                          </p>
                        </li>
                        <table>
                          <tbody>
                            <tr>
                              <th>ICB Subsector Impact Categories</th>
                              <th>Minimum Climate Change Scores</th>
                            </tr>
                            <tr>
                              <td>Primary Impact Subsectors</td>
                              <td>Score of 3 required</td>
                            </tr>
                            <tr>
                              <td>Secondary Impact Subsectors</td>
                              <td>Score of 1 required</td>
                            </tr>
                          </tbody>
                        </table>
                        <li>
                          <p>
                            Bursa Malaysia Bhd recuses itself from the awards.
                          </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </ol>

              <ol start="2">
                <li>
                  <p>Awards categories:</p>
                  <ol type="a">
                    <li>
                      <p>
                        Best performing company by Bursa Sector Classification
                        (12 sectors)
                      </p>
                    </li>
                    <li>
                      <p>
                        Most improved ESG performance over 3 years by market
                        capitalisation (4 categories)
                      </p>
                    </li>
                    <li>
                      <p>Most consistent performer over 5 years</p>
                    </li>
                    <li>
                      <p>Newcomer</p>
                    </li>
                    <li>
                      <p>Top 3 performers in ASEAN</p>
                    </li>
                    <li>
                      <p>Long-term achiever</p>
                      <ol type="i">
                        <li>
                          <p>
                            This is a special category for the inaugural 2022
                            ESG award.
                          </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>Methodology:</p>
                  <ol type="a">
                    <li>
                      <p>
                        For The Edge ESG Awards that is expected to be held in
                        November 2022, the FTSE4Good ESG rating score as of June
                        2022, which is the latest available data, will be used
                        as the measurement. The PLCs&rsquo; ESG rating score is
                        updated annually.
                      </p>
                    </li>
                    <li>
                      <p>
                        The FTSE4Good ESG ratings model looks at 14 themes,
                        which are underpinned by more than 300 indicators. An
                        exposure level of high, medium, low or negligible to
                        each theme is applied to each PLCs within the eligible
                        universe, based on the PLC&rsquo;s line of business.
                      </p>
                    </li>
                    <li>
                      <p>
                        The PLC is then assessed and scored using the relevant
                        indicators to see how well it is mitigating its ESG
                        risks.
                      </p>
                    </li>
                    <li>
                      <p>
                        The Climate Change score thresholds are based on the
                        enhanced FTSE4Good Index series Ground Rules. Thresholds
                        are determined by FTSE&rsquo;s classification of
                        developed and emerging markets, as well by PLCs&rsquo;
                        ICB Industry level classification.
                      </p>
                    </li>
                    <li>
                      <p>
                        The assessment is carried out by FTSE Russell based on
                        publicly-disclosed information, and a risk-exposure
                        weighted ESG score will be computed accordingly.
                      </p>
                    </li>
                    <li>
                      <p>
                        For more information click
                        <a
                          href="https://www.ftserussell.com/data/sustainability-and-esg-data/esg-ratings"
                          target="_blank"
                          >here</a
                        >
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
              <p>
                <span style="color: #008e43" class="text-uppercase"
                  ><strong>The Edge ESG Awards Funds Category</strong></span
                >
              </p>
              <ol>
                <li>
                  <p>Eligibility:</p>
                  <ol type="a">
                    <li>
                      <p>
                        Sustainable and Responsible Investment (SRI) Funds
                        recognised by the Securities Commission Malaysia, and
                      </p>
                    </li>
                    <li>
                      <p>
                        possess the Morningstar Sustainability Rating of 3
                        globes and above, and
                      </p>
                    </li>
                    <li>
                      <p>are launched before the year of award.</p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>Awards categories:</p>
                  <ol type="a">
                    <li>
                      <p>Best overall winner</p>
                    </li>
                    <li>
                      <p>Best fund based on asset class (3 categories)</p>
                    </li>
                    <li>
                      <p>Best impact (5 categories)</p>
                    </li>
                    <li>
                      <p>Best low carbon</p>
                    </li>
                    <li>
                      <p>Best in E, S and G</p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    Fund size and financial performance are not considered in
                    the assessment. However, if the winning fund generates
                    abnormally negative financial returns relative to the
                    overall market conditions, the event organisers will have
                    the discretion to adjust the results.
                  </p>
                </li>
                <li>
                  <p>
                    The assessments are based on latest information of the funds
                    as at 31 July 2022 (sustainability rating) and 30 June 2022
                    (carbon data) for The Edge ESG Awards 2022.
                  </p>
                </li>
                <li>
                  <p>Morningstar Sustainability Rating methodology:</p>
                  <ol type="a">
                    <li>
                      <p>
                        The Morningstar Sustainability Rating aims to help
                        investors evaluate relative ESG risks within portfolios.
                        The ratings are determined using a bottom-up assessment
                        of underlying holdings within a fund, underpinned by
                        Morningstar Sustainalytics&rsquo; methodology for
                        assessing corporate and sovereign ESG risk (see 5d). The
                        Rating is issued on a monthly basis.
                      </p>
                    </li>
                    <li>
                      <p>
                        The calculation of the rating score involves several
                        steps to represent the relative risk within each
                        portfolio. The output of the rating is a category of 1
                        to 5 &ldquo;globes&rdquo; for each eligible portfolio.
                      </p>
                    </li>
                    <li>
                      <p>
                        The higher the number of &ldquo;globes&rdquo;, the lower
                        the portfolio&rsquo;s ESG risk, relative to other funds
                        in the same category.
                      </p>
                    </li>
                    <li>
                      <p>
                        The Morningstar Sustainability Rating is calculated
                        using Sustainalytics&rsquo; ESG Risk Ratings for
                        corporate issuers and Sustainalytics&rsquo; Country Risk
                        Ratings for sovereign issuers, and is based on
                        historical holdings.
                      </p>
                      <ol type="i">
                        <li>
                          <p>
                            Sustainalytics&rsquo; ESG Risk Ratings measures a
                            company&rsquo;s exposure to industry-specific
                            material ESG risks and how well the company is
                            managing those risks.
                          </p>
                        </li>
                        <li>
                          <p>
                            Sustainalytics&rsquo; Country Risk Ratings assesses
                            a sovereign entity&rsquo;s socioeconomic wellbeing
                            by combining an assessment of the government
                            entity&rsquo;s current stock of capital with an
                            assessment of its ability to manage the wealth in a
                            sustainable manner.
                          </p>
                        </li>
                        <li>
                          <p>
                            For more information click
                            <a
                              href="https://www.morningstar.com/content/dam/marketing/shared/research/methodology/744156_Morningstar_Sustainability_Rating_for_Funds_Methodology.pdf"
                              target="_blank"
                              >here</a
                            >
                          </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
